import { LinkItem, PrivacyPolicyItems, PrivacyPolicyItemsContent, PrivacyPolicyItemsContentList, PrivacyPolicyItemsTitle, PrivacyPolicySubtitle, PrivacyPolicyTitle, Wrapper, } from "./style";

export const PrivacyPolicy = () => {
	return (
		<Wrapper>
			<PrivacyPolicyTitle>
				Политика конфиденциальности
				<PrivacyPolicySubtitle>
					в отношении обработки персональных данных 
				</PrivacyPolicySubtitle>
			</PrivacyPolicyTitle>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>
					1. Общие положения
				</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
					1.1. Настоящая Политика в отношении обработки персональных данных (далее — Политика) составлена в соответствии с п.2 ч.1 ст.18.1 Федерального закона РФ «О персональных данных» № 152-ФЗ от 27 июля 2006 года и действует в отношении всех персональных данных, обрабатываемых в ООО «С-Сервис» (далее — «Оператор»).
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					1.2. Целью разработки настоящей Политики является определение категорий персональных данных, обрабатываемых Оператором, а также основных принципов, которыми Оператор руководствуется при обработке персональных данных.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					1.3. Положения настоящей Политики являются обязательными для исполнения всеми работниками Оператора, организациями, получающими либо предоставляющие персональные данные Оператору, а также физическими лицами, находящимися в договорных отношениях с Оператором.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					1.4. В настоящей Политике используются следующие понятия:

					<PrivacyPolicyItemsContentList>
						– персональные данные — любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных);
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– оператор персональных данных (оператор) — государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– обработка персональных данных — любое действие (операция) или совокупность действий (операций) с персональными данными, совершаемых с использованием средств автоматизации или без их использования. Обработка персональных данных включает в себя, в том числе:
						
						<PrivacyPolicyItemsContentList>
							- сбор;
						</PrivacyPolicyItemsContentList>

						<PrivacyPolicyItemsContentList>
							- запись;
						</PrivacyPolicyItemsContentList>

						<PrivacyPolicyItemsContentList>
							- систематизацию;
						</PrivacyPolicyItemsContentList>

						<PrivacyPolicyItemsContentList>
							- накопление;
						</PrivacyPolicyItemsContentList>

						<PrivacyPolicyItemsContentList>
							- хранение;
						</PrivacyPolicyItemsContentList>

						<PrivacyPolicyItemsContentList>
							- уточнение (обновление, изменение);
						</PrivacyPolicyItemsContentList>

						<PrivacyPolicyItemsContentList>
							- извлечение;
						</PrivacyPolicyItemsContentList>

						<PrivacyPolicyItemsContentList>
							- использование;
						</PrivacyPolicyItemsContentList>

						<PrivacyPolicyItemsContentList>
							- передачу (распространение, предоставление, доступ);
						</PrivacyPolicyItemsContentList>

						<PrivacyPolicyItemsContentList>
							- блокирование;
						</PrivacyPolicyItemsContentList>

						<PrivacyPolicyItemsContentList>
							- удаление;
						</PrivacyPolicyItemsContentList>

						<PrivacyPolicyItemsContentList>
							- уничтожение.
						</PrivacyPolicyItemsContentList>
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– автоматизированная обработка персональных данных — обработка персональных данных с помощью средств вычислительной техники;
					</PrivacyPolicyItemsContentList>
					
					<PrivacyPolicyItemsContentList>
						– распространение персональных данных — действия, направленные на раскрытие персональных данных неопределенному кругу лиц;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– предоставление персональных данных — действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– блокирование персональных данных — временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных);
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– уничтожение персональных данных — действия, в результате которых становится невозможным восстановить содержание персональных данных в информационной системе персональных данных и (или) в результате которых уничтожаются материальные носители персональных данных;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– информационная система персональных данных — совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– трансграничная передача персональных данных — передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому лицу или иностранному юридическому лицу.
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– конфиденциальность персональных данных — обязанность Оператора и иных лиц, получивших доступ к персональным данным, не раскрывать третьим лицам и не распространять персональные данные без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом.
					</PrivacyPolicyItemsContentList>
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					1.5. Субъекты персональных данных или их законные представители имеют право:

					<PrivacyPolicyItemsContentList>
						– получать полную информацию о своих персональных данных и обработке этих данных (в том числе автоматизированной);
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– осуществлять свободный бесплатный доступ к своим персональным данным, включая право получать копии любой записи, содержащей персональные данные субъекта, за исключением случаев, предусмотренных федеральным законодательством РФ;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– требовать исключения или исправления неверных или неполных персональных данных, а также данных, обработка которых ведется с нарушением законодательства РФ;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– при отказе Оператора или уполномоченного им лица исключить или исправить персональные данные субъекта — заявить в письменной форме о своем несогласии, представив соответствующее обоснование;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– требовать от Оператора или уполномоченного им лица уведомления всех лиц, которым ранее были сообщены неверные или неполные персональные данные субъекта, обо всех произведенных в них изменениях или исключениях из них;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– обжаловать в суде любые неправомерные действия или бездействие Оператора или уполномоченного им лица, осуществляемые при обработке и защите персональных данных субъекта.
					</PrivacyPolicyItemsContentList>
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					1.6. Субъекты персональных данных или их законные представители, обязаны:

					<PrivacyPolicyItemsContentList>
						– предоставлять Оператору персональные данные, соответствующие действительности;	
					</PrivacyPolicyItemsContentList>
					
					<PrivacyPolicyItemsContentList>
						– своевременно уведомлять Оператора обо всех изменениях персональных данных.
					</PrivacyPolicyItemsContentList>
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					1.7. Оператор имеет право осуществлять обработку персональных данных при условии наличия законных оснований, соответствия процессов обработки заявленным целям обработки и требованиям законодательства Российской Федерации, положениям настоящей Политики и иных локальных актов Оператора.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					1.8. Оператор обязан:

					<PrivacyPolicyItemsContentList>
						– за свой счет обеспечить защиту персональных данных от неправомерного их использования или утраты в порядке, установленном законодательством РФ;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– предоставлять субъекту персональных данных по его запросу информацию, касающуюся обработки его персональных данных, либо на законных основаниях предоставить отказ;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– обеспечить субъекту свободный бесплатный доступ к своим персональным данным, включая право на получение копий любой записи, содержащей его персональные данные, за исключением случаев, предусмотренных законодательством РФ;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– по требованию субъекта персональных данных уточнять обрабатываемые персональные данные, блокировать или удалять, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– вести Журнал учета обращений субъектов персональных данных, в котором должны фиксироваться запросы субъектов персональных данных на получение персональных данных, а также факты предоставления персональных данных по этим запросам;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– уведомлять субъекта персональных данных об обработке персональных данных в том случае, если персональные данные были получены не от субъекта персональных данных;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– в случае достижения цели обработки персональных данных незамедлительно прекратить обработку персональных данных и уничтожить соответствующие персональные данные в срок, не превышающий тридцати дней с даты достижения цели обработки персональных данных, если иное не предусмотрено федеральным законодательством РФ;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– в случае направления запроса субъектом о прекращении обработки его персональных данных прекратить обработку персональных данных и уничтожить персональные данные в срок, не превышающий десяти рабочих дней с даты поступления указанного запроса. Указанный срок может быть продлен, но не более чем на пять рабочих дней в случае направления оператором в адрес субъекта персональных данных мотивированного уведомления с указанием причин продления срока предоставления запрашиваемой информации. Оператор вправе продолжить обработку персональных данных в случаях, предусмотренных пунктами 2 — 11 части 1 статьи 6, частью 2 статьи 10 и частью 2 статьи 11 Федерального закона № 152-ФЗ «О персональных данных»;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– предоставлять персональные данные субъекта только уполномоченным лицам и только в той части, которая необходима им для выполнения их трудовых обязанностей в соответствии с настоящим Положением и законодательством Российской Федерации.
					</PrivacyPolicyItemsContentList>
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>
					2. Цели обработки персональных данных
				</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
					2.1. Для каждой категории персональных данных Оператором определены и утверждены конкретные цели обработки. Обработка персональных данных, несовместимая с утвержденными целями, не допускается.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					2.2. Цели, категории субъектов, их объем и правовые основания обработки персональных данных, в рамках которых Оператор осуществляет обработку, приведены в Приложении № 2 к настоящей «Политике обработки персональных данных».
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					2.3. Обработка персональных данных, приведенных в Приложении № 2, помимо прочего, осуществляется в соответствии с требованиями Налогового кодекса РФ, Федерального закона № 402-ФЗ «О бухгалтерском учете», Федерального закона N 125-ФЗ «Об архивном деле в Российской Федерации», Приказа Росархива от 20.12.2019 N 236 «Об утверждении Перечня типовых управленческих архивных документов, образующихся в процессе деятельности государственных органов, органов местного самоуправления и организаций, с указанием сроков их хранения» Гражданским кодексом Российской Федерации, и другими Федеральными законами и принятыми на их основе нормативными правовыми актами, регулирующими отношения, связанные с деятельностью Оператора, а также иных нормативно-правовых актов Российской Федерации, в рамках осуществления и выполнения, возложенных законодательством Российской Федерации на Оператора функций, полномочий и обязанностей.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					2.4. Обрабатываемые персональные данные подлежат уничтожению либо обезличиванию по окончании срока хранения, достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено законодательством.
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>
					3. Порядок и условия обработки персональных данных
				</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
					3.1. Все персональные данные Оператор получает непосредственно от субъекта персональных данных, от его представителя либо от лица, поручившего Оператору обработку персональных данных, за исключением случаев, предусмотренных законодательством РФ.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.2. Обработка персональных данных осуществляется с согласия субъекта персональных данных, за исключением случаев, предусмотренных законодательством РФ. Согласие может быть выражено в различных формах, позволяющих подтвердить факт его получения, в том числе в конклюдентных действиях, в письменном виде в форме отдельного документа, либо в составе какого-либо документа, подписываемого субъектом. Согласие может быть дано представителем субъекта, при предоставлении им доказательств своих полномочий.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.3. Согласие на обработку персональных данных может быть отозвано субъектом персональных данных. В случаях, предусмотренных законодательством РФ, обработка персональных данных может быть продолжена даже после отзыва субъектом согласия на обработку.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.4. При принятии решений, затрагивающих интересы субъекта, Оператор никогда не основывается на персональных данных субъекта, полученных исключительно в результате их автоматизированной обработки или электронного получения.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.5. Персональные данные не используются в целях причинения имущественного и/или морального вреда гражданам, затруднения реализации прав и свобод граждан Российской Федерации.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.6. Доступ к персональным данным имеют работники Оператора, которым персональные данные необходимы в связи с исполнением ими должностных обязанностей.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					3.7. Передача персональных данных работника Оператора третьим лицам осуществляется только с письменного согласия субъекта, за исключением случаев, предусмотренных законодательством РФ.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					3.8. Оператор вправе передавать персональные данные органам дознания и следствия, иным уполномоченным органам по основаниям, предусмотренным действующим законодательством Российской Федерации.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					3.9. Оператор вправе создавать общедоступные источники персональных данных, в которые могут включаться персональные данные субъекта персональных данных с его письменного согласия.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					3.10. Передача персональных данных субъекта в коммерческих целях без его письменного согласия не осуществляется.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.11. В случае необходимости передачи Оператором персональных данных третьим лицам, она осуществляется только после подписания между Оператором и третьей стороной соглашения о неразглашении конфиденциальной информации, за исключением случаев, предусмотренных законодательством РФ.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.12. Обработка персональных данных осуществляется как использованием средств вычислительной техники, так и без использования таковых средств.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.13. Сроки обработки персональных данных Оператором в общем случае определяются в соответствии со сроками, установленными Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных»; сроком действия соответствующего договора; сроками, оговоренными в поручении на обработку персональных данных; сроками действия документов, установленными Федерального закона N 125-ФЗ «Об архивном деле в Российской Федерации»; Приказа Росархива от 20.12.2019 N 236 «Об утверждении Перечня типовых управленческих архивных документов, образующихся в процессе деятельности государственных органов, органов местного самоуправления и организаций, с указанием сроков их хранения», сроком исковой давности; сроком действия согласия, данного субъектом персональных данных на их обработку; а также иными требованиями законодательства Российской Федерации.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.14. Персональные данные при их обработке, осуществляемой без использования средств автоматизации, обособляются от иной информации, в частности путем фиксации их на отдельных материальных носителях персональных данных (далее — материальные носители), в специальных разделах или на полях форм (бланков).
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.15. При фиксации персональных данных на материальных носителях не допускается фиксация на одном материальном носителе персональных данных, цели обработки которых заведомо не совместимы. Для обработки различных категорий персональных данных, осуществляемой без использования средств автоматизации, для каждой категории персональных данных используется отдельный материальный носитель.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.16. Лица, осуществляющие обработку персональных данных без использования средств автоматизации, должны быть проинформированы о факте обработки ими персональных данных, обработка которых осуществляется оператором без использования средств автоматизации, категориях обрабатываемых персональных данных, а также об особенностях и правилах осуществления такой обработки.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.17. При использовании типовых форм документов, заполняемых субъектом персональных данных собственноручно, характер информации в которых предполагает или допускает включение в них персональных данных (далее — типовая форма), соблюдаются следующие условия:

					<PrivacyPolicyItemsContentList>
						– типовая форма или связанные с ней документы (инструкция по ее заполнению, карточки, реестры и журналы) должны содержать сведения о цели обработки персональных данных, осуществляемой без использования средств автоматизации, имя (наименование) и адрес оператора, фамилию имя, отчество и адрес субъекта персональных данных, источник получения персональных данных, сроки обработки персональных данных, перечень действий с персональными данными, которые будут совершаться в процессе их обработки, общее описание используемых оператором способов обработки персональных данных;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– типовая форма должна предусматривать поле, в котором субъект персональных данных может поставить отметку о своем согласии на обработку персональных данных, осуществляемую без использования средств автоматизации — при необходимости получения письменного согласия на обработку персональных данных;
					</PrivacyPolicyItemsContentList>
					
					<PrivacyPolicyItemsContentList>
						– типовая форма должна быть составлена таким образом, чтобы каждый из субъектов персональных данных, содержащихся в документе, имел возможность ознакомиться со своими персональными данными, содержащимися в документе, не нарушая прав и законных интересов иных субъектов персональных данных;  типовая форма должна исключать объединение полей, предназначенных для внесения персональных данных, цели обработки которых заведомо несовместимы.
					</PrivacyPolicyItemsContentList>
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					3.18. Персональные данные подлежат уничтожению по достижении целей обработки, в случае утраты необходимости в их достижении, по истечении срока хранения, при выявлении факта неправомерной обработки либо по требованию лица, поручившего обработку персональных данных в срок, не превышающий десяти рабочих дней с даты достижения цели обработки персональных данных, либо получения отзыва на их обработку. Указанный срок может быть продлен, но не более чем на пять рабочих дней в случае направления оператором в адрес субъекта персональных данных мотивированного уведомления с указанием причин продления срока предоставления запрашиваемой информации. Уничтожение осуществляется в присутствии комиссии. По итогам составляется акт об уничтожении.
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>
					4. Защита персональных данных
				</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
					4.1. Оператор обеспечивает защиту персональных данных субъекта от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, распространения персональных данных, а также от иных неправомерных действий.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					4.2. Защита персональных данных обеспечивается Оператором в установленном действующим законодательством РФ и локальными актами Оператора порядке, путем выполнения комплекса организационно—технических мероприятий, обеспечивающих их безопасность.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					4.3. Все меры защиты при сборе, обработке, хранении и передаче персональных данных субъекта распространяются как на бумажные, так и на электронные (автоматизированные) носители информации.
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>
					5. Актуализация, исправление, удаление и уничтожение персональных данных
				</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
					5.1. Оператор имеет право внести, дополнить, изменить, блокировать или удалить персональные данные в соответствии с Федеральным законодательством Российской Федерации.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					5.2. По запросу субъекта персональных данных Оператор обязан:

					<PrivacyPolicyItemsContentList>
						– предоставить сведения о наличии у оператора персональных данных субъекта;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– предоставить возможность ознакомления с персональными данными субъекта (исключение ФЗ-152 статья 14 часть 5) и предоставить информацию, касающуюся обработки его персональных данных в соответствии с ФЗ-152;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– уточнить недостоверные или изменившиеся персональные данные;
					</PrivacyPolicyItemsContentList>

					<PrivacyPolicyItemsContentList>
						– блокировать или уничтожить персональные данные в случае, если они являются незаконно полученными, не являются необходимыми для заявленной цели обработки или отозвано согласие субъекта.
					</PrivacyPolicyItemsContentList>
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					5.3. Запрос субъекта персональных данных должен быть отправлен Оператору в бумажном виде и содержать номер основного документа, удостоверяющего личность субъекта персональных данных или его законного представителя, сведения о дате выдачи указанного документа и выдавшем его органе, и собственноручную подпись субъекта персональных данных или его законного представителя. Типовая форма запроса представлена в Приложении 1 к настоящей Политике.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					5.4. Запрос может быть направлен в электронной форме и подписан электронной цифровой подписью в соответствии с законодательством Российской Федерации на электронную почту: avia@dushanbe24.ru.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					5.5. При поступлении запроса обращения субъектов, ответственный работник Оператора обязан зарегистрировать такой запрос в журнале регистрации обращений субъектов.
				</PrivacyPolicyItemsContent>
				
				<PrivacyPolicyItemsContent>
					5.6. Ответ, либо мотивированный отказ, должны быть отправлены в течение десяти рабочих дней с даты получения запроса от субъекта персональных данных. Указанный срок может быть продлен, но не более чем на пять рабочих дней в случае направления оператором в адрес субъекта персональных данных мотивированного уведомления с указанием причин продления срока предоставления запрашиваемой информации. Ответ должен быть в форме, в которой направлены соответствующие обращение либо запрос, если иное не указано в обращении или запросе и содержать конкретную и исчерпывающую информацию, касающуюся сути вопроса.
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>6. Изменение Политики</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
					6.1. Оператор имеет право вносить изменения в настоящую Политику. При внесении изменений в заголовке Политики указывается дата последнего обновления редакции. Новая редакция Политики вступает в силу с момента ее размещения на сайте Оператора, если иное не предусмотрено новой редакцией Политики.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					6.2. Действующая редакция хранится в месте нахождения исполнительного органа Оператора по адресу: 142046, Московская область, городской округ Домодедово, 40 км трассы А-105, стр.3, офис №88, электронная версия Политики — на сайте Оператора по адресу: <LinkItem to='https://as.dushanbe24.ru/privacy-policy-info/' target='blank'>as.dushanbe24.ru/privacy-policy-info</LinkItem>.
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					6.3. К настоящей Политике и отношениям между субъектами персональных данных и Оператором подлежит применению право Российской Федерации.
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>

			<PrivacyPolicyItems>
				<PrivacyPolicyItemsTitle>7. Обратная связь</PrivacyPolicyItemsTitle>

				<PrivacyPolicyItemsContent>
					7.1. Адрес электронной почты: <LinkItem to='mailto:avia@dushanbe24.ru'>avia@dushanbe24.ru</LinkItem>

				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					7.2. Почтовый адрес: 142046, Московская область, городской округ Домодедово, 40 км трассы А-105, стр.3, офис №88
				</PrivacyPolicyItemsContent>

				<PrivacyPolicyItemsContent>
					7.3. Контактный номер телефона: <LinkItem to='tel:+79856344104'>+7(985)634-41-04</LinkItem>
				</PrivacyPolicyItemsContent>
			</PrivacyPolicyItems>
		</Wrapper>
	);
};